<!--
 * @Author: kztai 1012049531@qq.com
 * @Date: 2022-05-30 11:26:24
 * @LastEditors: kztai 1012049531@qq.com
 * @LastEditTime: 2022-06-23 19:15:22
 * @FilePath: \vue-cli\src\components\calendar.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="wtc-choose-calendar">

        <div class="wtc-choose-calendar-week">
            <div class="wtc-choose-calendar-week-item" v-for="item in week" :key="item" :class="{'weekend': item === '六' || item === '日'}">
                {{ item }}
            </div>
        </div>

      <div class="wtc-choose-calendar-head">
        <div class="wtc-choose-calendar-left-month-btn kdfont kdfont-qianfan"
             :class="{'wtc-choose-calendar-left-month-btn-disable': isEarliestMonth}" @click="preMonthClick">
        </div>
        <div class="wtc-choose-calendar-cur-month" @click="showYearPicker">
          {{ selectYear }}年{{ selectMonth }}月
        </div>
        <div class="wtc-choose-calendar-right-month-btn kdfont kdfont-houfan" @click="nextMonthClick"></div>
      </div>

        <div class="wtc-choose-calendar-content-wrap" style="transform: translateX(-33.333%);">
            <div class="wtc-choose-calendar-content content-pre-month" >
                <div class="wtc-choose-calendar-content-date-wrap" v-for="(item, index) in arrPreDate" :key="index"
                     :class="{'pre-date': item.type === 'pre','cur-date': item.type === 'cur',
          'next-date': item.type === 'next',}">
                    <div class="wtc-choose-calendar-content-date">
                        <div class="wtc-choose-calendar-content-date-mark"></div>
                        <div class="wtc-choose-calendar-content-date-text">
                            {{ item.value }}
                        </div>
                        <div class="wtc-choose-calendar-content-date-apply"></div>
                    </div>
                </div>
            </div>
            <div class="wtc-choose-calendar-content content-cur-month" >
                <div class="wtc-choose-calendar-content-date-wrap" v-for="(item, index) in arrCurDate" :key="index"
                     :class="[
        {
          'pre-date': item.type === 'pre',
          'cur-date': item.type === 'cur',
          'next-date': item.type === 'next',
          // 'choosed-date': item.value === selectDate,
        },
        `date-${item.date}`,
      ]" @click="dateClick($event, item.date, item.type)">
                    <div class="wtc-choose-calendar-content-date" :class="{
          'wtc-cld-date-actual-work':
            !item.off &&
            (item.dateAttribute === 'OFFDAY' ||
              item.dateAttribute === 'HOLIDAY'),
          'wtc-cld-date-actual-off':
            (item.off && item.dateAttribute === 'WORKDAY') ||
            item.dateAttribute === 'HOLIDAY',
          'wtc-cld-date-rest': item.dateAttribute === 'OFFDAY',
          'wtc-cld-date-today': item.today,
        }">
                        <div class="wtc-choose-calendar-content-date-mark" v-if="
            (item.off && item.dateAttribute === 'WORKDAY') ||
            item.dateAttribute === 'HOLIDAY'
          ">
                            休
                        </div>
                        <div class="wtc-choose-calendar-content-date-mark"
                             v-if="!item.off && (item.dateAttribute === 'OFFDAY' || item.dateAttribute === 'HOLIDAY')">
                            班
                        </div>
                        <div class="wtc-choose-calendar-content-date-text">
<!--                            {{ item.today ? "今" : item.value }}-->
                          {{ item.value }}
                        </div>
<!--                        <div v-if="item.abnormal" class="wtc-choose-calendar-content-date-apply">
                            <div class="wtc-choose-calendar-content-date-apply-inner"></div>
                        </div>-->
                      <div v-if="item.today" class="wtc-choose-calendar-content-date-apply">
                        <div class="wtc-choose-calendar-content-date-apply-inner"></div>
                      </div>
                        <div v-else-if="item.holiday" class="wtc-choose-calendar-content-date-apply">
                            {{ item.holiday }}
                        </div>
                        <div v-else class="wtc-choose-calendar-content-date-apply" :title="item.billListText">
                            {{ item.billListText }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="wtc-choose-calendar-content content-next-month" >
                <div class="wtc-choose-calendar-content-date-wrap" v-for="(item, index) in arrNextDate" :key="index"
                     :class="{'pre-date': item.type === 'pre','cur-date': item.type === 'cur',
          'next-date': item.type === 'next',}">
                    <div class="wtc-choose-calendar-content-date">
                        <div class="wtc-choose-calendar-content-date-mark"></div>
                        <div class="wtc-choose-calendar-content-date-text">
                            {{ item.value }}
                        </div>
                        <div class="wtc-choose-calendar-content-date-apply"></div>
                    </div>
                </div>
            </div>
        </div>
        <dialogWrap ref="dialogWrap" @hideDialog="hideYearPicker" :showWrap="showWrap">
            <selectYearMonth :year="selectYear" :month="selectMonth" :earliestMonth="earliestMonth" :showWrap="showWrap"
                             @cancelClick="hideYearPicker" @confirmClick="yearPickerConfirm"></selectYearMonth>
        </dialogWrap>
    </div>
</template>

<script>
    import selectYearMonth from "./selectYearMonth.vue";
    import dialogWrap from "./dialogWrap.vue";

    export default {
        name: "calendar",
        components: {
            selectYearMonth,
            dialogWrap,
        },
        props: ["calendarType","currentMonth", "model", 'earliestMonth', 'maxChoose', "dateList", 'KDApi'],
        data() {
            return {
                week: ["日", "一", "二", "三", "四", "五", "六"],
                selectYear: 2022,
                selectMonth: 10,
                selectDate: 1,
                standardDate: new Date(), // 默认显示年月
                arrCurDate: [],
                arrPreDate: [],
                arrNextDate: [],
                today: "",
                showWrap: false,  // 控制年月选择器的显示与隐藏
                isEarliestMonth: false,
                timer: null,
                chooseDate:[],
                chooseMiddleDate:[],
            };
        },

        mounted() {
            this.today = this.formatDate(new Date(), "date");
            let tempDay = new Date().getDate();
            let currentMonth = this.currentMonth;
            if(currentMonth === undefined || currentMonth == null){
              currentMonth = this.getCurrentYearMonth();
            }
            this.init(currentMonth.split('-')[0], currentMonth.split('-')[1], tempDay);
        },

        watch: {
            yearMonth(newValue, oldValue) {
                this.init(newValue.split('-')[0], newValue.split('-')[1], this.selectDate);
            },
          arrCurDate:function (){
              this.$nextTick(()=>{
                this.dateInit();
              })
          }
        },

        methods: {
            init(year, month, date) {
                let resultDate = this.toExistDate(year, month, date);
                this.standardDate = new Date(resultDate);
                this.chooseDate = this.dateList;
                this.refreshCalendar();
            },

            refreshCalendar() {
                let $this = this;
                this.selectYear = this.getYear(this.standardDate);
                this.selectMonth = this.getMonth(this.standardDate);
                this.selectDate = this.getDate(this.standardDate);

                // 渲染当前月日期
                this.getMonthDate(this.selectYear, this.selectMonth, this.arrCurDate);

                // 渲染上个月日期
                let temp = this.getPreMonth(this.selectYear, this.selectMonth);
                this.getMonthDate(temp.year, temp.month, this.arrPreDate);

                // 渲染下个月日期
                temp = this.getNextMonth(this.selectYear, this.selectMonth);
                this.getMonthDate(temp.year, temp.month, this.arrNextDate);

                // 设置当前月的日期面板的高度：
                /*if ($this.arrCurDate.length > 35) {
                    this.$el.style.height = "410px";
                } else if ($this.arrCurDate.length < 35) {
                    this.$el.style.height = "302px";
                } else {
                    this.$el.style.height = "356px";
                }*/
              let windowWidth = document.body.clientWidth;
              if ($this.arrCurDate.length > 35) {
                this.$el.style.height = ((windowWidth/7+8)*6+77.8)+"px";
              } else if ($this.arrCurDate.length < 35) {
                this.$el.style.height = ((windowWidth/7+8)*4+77.8)+"px";
              } else {
                this.$el.style.height = ((windowWidth/7+8)*5+77.8)+"px";
              }
              //this.dateInvoke();
            },

            /*
             * 请求插件中获取到的日期
             */
          dateInit() {
              this.addChooseDate();
            },
            /*
             * 返回已选中日期
             */
            dateChooseInvoke() {
              this.chooseDate.sort((dateA,dateB) => this.dateCompare(dateA, dateB));
              this.model.invoke("dateChoose", this.chooseDate);
            },

            /*
             * 计算出当前年月对应的所有需显示日期
             */
            getMonthDate(year, month, arrDate) {
                let preYearMonth = this.getPreMonth(year, month);
                let nextYearMonth = this.getNextMonth(year, month);

                // 获取上个月最后一天
                let preMonthLastDate = this.getPreMonthLastDate(year, month);
                // 获取本月最后一天
                let curMonthLastDate = this.getPreMonthLastDate(nextYearMonth.year, nextYearMonth.month);

                // 获取当前年月的第一天对应是星期几：
                let tempDate = year + "/" + month + "/01";
                let fisrtDateWeek = new Date(tempDate).getDay(); //星期天是0，星期六是6

                // 获取当前年月的最后一天对应是星期几：
                tempDate = year + "/" + month + "/" + curMonthLastDate;
                let lastDateWeek = new Date(tempDate).getDay(); //星期天是0，星期六是6

                arrDate.length = 0; // 清空原数据
                for (let i = 1; i <= curMonthLastDate; i++) {
                    let istoday = this.isToday(year, month, i);
                    // 默认选中的日期为今天
                    // if (istoday) this.selectDate = i;

                    arrDate.push({
                        value: i,
                        type: "cur",
                        date: this.formatDate_zero(year, month, i),
                        today: istoday,
                        holiday: "",
                        dateAttribute: "",
                        off: false,
                        billListText: "",
                        abnormal: false,
                    });
                }

                for (let i = 0; i < fisrtDateWeek; i++) {
                    arrDate.unshift({
                        value: '-' + (preMonthLastDate - i),
                        type: "pre",
                        date: this.formatDate_zero(preYearMonth.year, preYearMonth.month, preMonthLastDate - i),
                        today: this.isToday(preYearMonth.year, preYearMonth.month, preMonthLastDate - i),
                        holiday: "",
                        dateAttribute: "",
                        off: false,
                        billListText: "",
                        abnormal: false,
                    });
                }

                for (let i = 0; i < 6 - lastDateWeek; i++) {
                    arrDate.push({
                        value: '+' + (i + 1),
                        type: "next",
                        date: this.formatDate_zero(nextYearMonth.year, nextYearMonth.month, i + 1),
                        today: this.isToday(nextYearMonth.year, nextYearMonth.month, i + 1),
                        holiday: "",
                        dateAttribute: "",
                        off: false,
                        billListText: "",
                        abnormal: false,
                    });
                }
            },

            showYearPicker() {
                this.showWrap = true;
            },

            hideYearPicker() {
                this.showWrap = false;
            },

            addDateData(arrData) {
                let index = 0;
                for (let i = 0; i < this.arrCurDate.length; i++) {
                    if (this.arrCurDate[i].type === 'cur' && arrData[index]) {
                        this.arrCurDate[i].holiday = arrData[index].holiday;
                        this.arrCurDate[i].dateAttribute = arrData[index].dateAttribute;
                        this.arrCurDate[i].off = arrData[index].off;
                        this.arrCurDate[i].billListText = arrData[index].billList ? arrData[index].billList.join(",") : '';
                        this.arrCurDate[i].abnormal = arrData[index].abnormal;
                        index++;
                    }
                }
            },
          // lhb 添加已选择日期
          addChooseDate() {
            let $this = this;
            // 取消所有选中
            let arrDom_contentDate = this.$el.querySelectorAll(
                ".content-cur-month .wtc-choose-calendar-content-date-wrap"
            );
            arrDom_contentDate.forEach(function (item) {
              $this.removeClass(item, "choosed-date");
              $this.removeClass(item, "middle-choosed-date");
              $this.removeClass(item, "middle-start-choosed-date");
              $this.removeClass(item, "middle-end-choosed-date");
            });
            // 日期为空时，直接返回
            if(this.chooseDate == null || this.chooseDate.length ===0){
              return;
            }
            this.chooseDate.sort((dateA,dateB) => this.dateCompare(dateA, dateB));
            // 首先判断当前日期使用类型，多选日期-choose 日期范围-range,范围时需要处理中间日期的选中样式
            // 日期范围时，且已选中日期个数为2，则高亮中间日期
            if($this.calendarType === "RANGE" && this.chooseDate.length === 2){
                $this.chooseMiddleDate = $this.getAllChoosedDate(this.chooseDate[0], this.chooseDate[1]);
                // 排除两个日期相等的情况
                if($this.chooseMiddleDate.length >1){
                  for (let i = 0; i < $this.chooseMiddleDate.length; i++) {
                    // 高亮日期范围内日期
                    let dom_checkedDate = this.$el.querySelector(`.date-${$this.chooseMiddleDate[i]}`);
                    if(dom_checkedDate != null){
                      dom_checkedDate.className = dom_checkedDate.className + " middle-choosed-date";
                      if(i === 0){
                        dom_checkedDate.className = dom_checkedDate.className + " middle-start-choosed-date";
                      } else if(i === $this.chooseMiddleDate.length-1){
                        dom_checkedDate.className = dom_checkedDate.className + " middle-end-choosed-date";
                      }
                    }
                  }
                }

            }

            for (let i = 0; i < this.chooseDate.length; i++) {
              // 高亮当前选中
              let dom_checkedDate = this.$el.querySelector(`.date-${this.chooseDate[i]}`);
              if(dom_checkedDate != null){
                dom_checkedDate.className = dom_checkedDate.className + " choosed-date";
              }
            }

          },

          updateChooseDate(dateList) {
            this.chooseDate = dateList;
            this.addChooseDate();
          },

          // lhb 高亮已选择日期
          /*dealChoosedDate() {
              let $this = this;
              // 取消所有选中
              let arrDom_contentDate = this.$el.querySelectorAll(
                  ".content-cur-month .wtc-choose-calendar-content-date-wrap"
              );
              arrDom_contentDate.forEach(function (item) {
                $this.removeClass(item, "choosed-date");
              });
              for (let i = 0; i < this.chooseDate.length; i++) {
                // 高亮当前选中
                let dom_checkedDate = this.$el.querySelector(`.date-${this.chooseDate[i]}`);
                dom_checkedDate.className = dom_checkedDate.className + " choosed-date";
              }
          },*/

            isToday(year, month, date) {
                month = month > 9 ? month : "0" + month;
                date = date > 9 ? date : "0" + date;
                return year + "-" + month + "-" + date === this.today;
            },

            /*
             * 点击日期，如果点击的是下一个月的日期，则切换到下一个月
             */
            dateClick($event, date, type) {
                if (type !== 'cur') return;  //TODO: 当前版本只需实现点击本月的日期，点击上月/下月保留，以防需求更改

                let $this = this;
                let tempDate = Number(date.split("-")[2]);

                this.selectDate = tempDate;
                if (type === "pre") {
                  this.preMonthClick(function () {
                    date =
                        $this.selectYear + "-" + $this.selectMonth + "-" + $this.selectDate;
                    $this.$nextTick(function () {
                      $this.changeCheckedDate(date);
                    });
                  });
                } else if (type === "next") {
                  this.nextMonthClick(function () {
                    date =
                        $this.selectYear + "-" + $this.selectMonth + "-" + $this.selectDate;
                    $this.$nextTick(function () {
                      $this.changeCheckedDate(date);
                    });
                  });
                } else {
                  this.changeCheckedDate(date);
                }
            },

            exceedToday(year, month, date) {
                let destTimestamp = new Date(year + '/' + month + '/' + date + ' 00:00').getTime();
                let temp = (this.today + ' 00:00').replace(/-/g, '/');
                let todayTimestamp = new Date(temp).getTime();
                return destTimestamp > todayTimestamp;
            },

            /*
             * 切换高亮的日期
             */
            changeCheckedDate(date) {
              let $this = this;
              if(this.chooseDate === null || this.chooseDate === undefined){
                this.chooseDate = [];
              }
              // 首先判断当前日期使用类型，多选日期-choose 日期范围-range,范围时需要判断当前选中个数，无选中时，与多选日期一致
              // 存在一个选中日期时，首先排序日期，然后处理范围日期内的选择状态
              // 存在两个选中日期时，需要清空选中日期，重新选中日期
              if(this.calendarType === "RANGE"){
                if(this.chooseDate.length === 0){  // 还未有选中日期
                  // 高亮当前选中
                  let dom_checkedDate = this.$el.querySelector(`.date-${date}`);
                  dom_checkedDate.className = dom_checkedDate.className + " choosed-date";
                  this.chooseDate.push(date);
                  // 提示需要选择结束日期
                  // $this.$root.myTool.message({type: 'warn', message: this.KDApi.getLangMsg(this.model, 'endDateTip')})
                  $this.$root.myTool.message_soft({type: 'warn', message: this.KDApi.getLangMsg(this.model, 'endDateTip')})
                }else if(this.chooseDate.length === 1){ // 已经选中一个日期，首先判断是否重复点击，否则是正常范围
                  if(date === this.chooseDate[0]){
                    // 选择同一日期时，说明日期范围是同一天
                    this.chooseDate.push(date);
                    this.chooseMiddleDate.length = 0;
                    this.chooseMiddleDate.push(date);
                    this.dateChooseInvoke();
                    return;
                  }
                  // 高亮当前选中
                  let dom_checkedDate = this.$el.querySelector(`.date-${date}`);
                  dom_checkedDate.className = dom_checkedDate.className + " choosed-date";
                  this.chooseDate.push(date);
                  $this.chooseMiddleDate = $this.getAllChoosedDate(this.chooseDate[0], this.chooseDate[1]);
                  for (let i = 0; i < $this.chooseMiddleDate.length; i++) {
                    // 高亮日期范围内日期
                    let dom_checkedDate = this.$el.querySelector(`.date-${$this.chooseMiddleDate[i]}`);
                    if(dom_checkedDate != null){
                      dom_checkedDate.className = dom_checkedDate.className + " middle-choosed-date";
                      if(i === 0){
                        dom_checkedDate.className = dom_checkedDate.className + " middle-start-choosed-date";
                      } else if(i === $this.chooseMiddleDate.length-1){
                        dom_checkedDate.className = dom_checkedDate.className + " middle-end-choosed-date";
                      }
                    }
                  }
                }else{  // 选中两个日期,清空已经选择的日期范围，重新选择
                  this.chooseMiddleDate.forEach(item =>{
                      let dom_checkedDate = this.$el.querySelector(`.date-${item}`);
                      if(dom_checkedDate !== null && dom_checkedDate !== undefined){
                        $this.removeClass(dom_checkedDate, "choosed-date");
                        $this.removeClass(dom_checkedDate, "choosed-date");
                        $this.removeClass(dom_checkedDate, "middle-choosed-date");
                        $this.removeClass(dom_checkedDate, "middle-start-choosed-date");
                        $this.removeClass(dom_checkedDate, "middle-end-choosed-date");
                      }

                  });
                  this.chooseMiddleDate.length = 0;
                  this.chooseDate.length = 0;
                  // 高亮当前选中
                  let dom_checkedDate = this.$el.querySelector(`.date-${date}`);
                  dom_checkedDate.className = dom_checkedDate.className + " choosed-date";
                  this.chooseDate.push(date);
                  // 提示需要选择结束日期
                  $this.$root.myTool.message_soft({type: 'warn', message: this.KDApi.getLangMsg(this.model, 'endDateTip')})
                }
              }else{

                // 判断是否已选中，已选中取消选中，未选中则高亮
                let flag = false;
                this.chooseDate.forEach(item =>{
                  if(item === date){
                    let dom_checkedDate = this.$el.querySelector(`.date-${date}`);
                    $this.removeClass(dom_checkedDate, "choosed-date");
                    let index = this.chooseDate.indexOf(item);
                    this.chooseDate.splice(index,1);
                    flag = true;
                  }
                });
                this.model.invoke("dateChoose", this.chooseDate);
                if(flag) return
                // 首先判断已选日期是否超过最大要求
                if(this.maxChoose !== null && this.maxChoose !== undefined && this.maxChoose > 0 && this.chooseDate.length >= this.maxChoose){
                  $this.$root.myTool.message_soft({type: 'warn', message: this.KDApi.getLangMsg(this.model, 'maxChooseTip')+this.maxChoose})
                  return;
                }
                // 高亮当前选中
                let dom_checkedDate = this.$el.querySelector(`.date-${date}`);
                dom_checkedDate.className = dom_checkedDate.className + " choosed-date";
                this.chooseDate.push(date);
              }
              this.dateChooseInvoke();
            },

            /*
             * 点击向前一月按钮
             */
            preMonthClick(callback) {
                if (this.isEarliestMonth) return;   // 已是可点击的最早月份
                if(this.timer) return;  // 上一个点击动画还没有结束，不允许再点击

                let $this = this;
                let temp = this.getPreMonth(this.selectYear, this.selectMonth);
                // 还需判断该日期是否存在：
                let tempDate = this.toExistDate(temp.year, temp.month, this.selectDate);
                this.standardDate = new Date(tempDate);

                this.moveAnimation('left', function () {
                    $this.refreshCalendar();
                    $this.$el.querySelector(".wtc-choose-calendar-content-wrap").style.transform = "translateX(-33.333%)";
                    if (callback && typeof callback === 'function') callback();
                });
            },

            /*
             * 点击向后一月按钮
             */
            nextMonthClick(callback) {
                if(this.timer) return;  // 上一个点击动画还没有结束，不允许再点击

                let $this = this;
                let temp = this.getNextMonth(this.selectYear, this.selectMonth);

                this.isEarliestMonth = false;

              // 还需判断该日期是否存在：
              let tempDate = this.toExistDate(temp.year, temp.month, this.selectDate);
              this.standardDate = new Date(tempDate);

                this.moveAnimation('right', function () {
                  $this.refreshCalendar();
                  $this.$el.querySelector(".wtc-choose-calendar-content-wrap").style.transform = "translateX(-33.333%)";
                  if (callback && typeof callback === 'function') callback();
                });
            },


            yearPickerConfirm(yearMonth) {
                // 判断是否超过本月，大于则提示“不允许查看未来数据”
                let exceedMonth = this.exceedToday(yearMonth.year, yearMonth.month, 1);
              exceedMonth = false;
                if (exceedMonth) {
                    this.$root.myTool.message_soft({type: 'warn', message: '不允许查看未来数据'})
                    // alert('不允许查看未来数据')
                } else {
                    /*// 判断是否大于今天，大于则定位到今天，否则定位到selectDate：
                    let exceedToday1 = this.exceedToday(yearMonth.year, yearMonth.month, this.selectDate);
                    if (exceedToday1) {
                        this.standardDate = new Date();
                    } else {
                        // 还需判断该日期是否存在：
                        let tempDate = this.toExistDate(yearMonth.year, yearMonth.month, this.selectDate);
                        this.standardDate = new Date(tempDate);
                    }*/
                  // 还需判断该日期是否存在：
                  let tempDate = this.toExistDate(yearMonth.year, yearMonth.month, this.selectDate);
                  this.standardDate = new Date(tempDate);
                    this.refreshCalendar();
                    this.hideYearPicker();
                }
            },

            toExistDate(year, month, date) {
                // 先判断该日期是否存在：
                if (new Date(year + "/" + month + "/" + date).getDate() === date) {
                    return year + "/" + month + "/" + date;
                } else {
                    let nextYearMonth = this.getNextMonth(year, month);
                    let lastDay = this.getPreMonthLastDate(nextYearMonth.year, nextYearMonth.month);
                    return year + "/" + month + "/" + lastDay;
                }
            },

            /*
             * 获取当前年月对应的上一个年月
             */
            getPreMonth(year, month) {
                return month === 1
                    ? {
                        year: --year,
                        month: 12,
                    }
                    : {
                        year: year,
                        month: --month,
                    };
            },

            /*
             * 获取当前年月对应的正确值
             * month会存在13或0
             */
            // getTrueMonth(year, month) {
            //   return month === 0
            //     ? {
            //         year: --year,
            //         month: 12,
            //       }
            //     : month === 13
            //     ? {
            //         year: ++year,
            //         month: 1,
            //       }
            //     : {
            //         year,
            //         month,
            //       };
            // },

            /*
             * 获取当前年月对应的下一个年月
             */
            getNextMonth(year, month) {
                return month === 12
                    ? {
                        year: ++year,
                        month: 1,
                    }
                    : {
                        year: year,
                        month: ++month,
                    };
            },

            /*
             * 渲染向前向后一个月的动画效果
             */
            moveAnimation(type, callback) {
                let $this = this;
                let dom_contentWrap = this.$el.querySelector(".wtc-choose-calendar-content-wrap");
                let num = -33;
                this.timer = setInterval(function () {
                    type === 'left' ? ++num : --num;
                    dom_contentWrap.style.transform = `translateX(${num}%)`;
                    if (type === 'left' ? num >= 0 : num <= -66) {
                        clearInterval($this.timer);
                        $this.timer = null;
                        callback();
                    }
                }, 2);
            },

            /*
             * 返回上个月最后一天
             */
            getPreMonthLastDate(year, month) {
                let tempDate = year + "/" + month + "/01 00:00:00";
                let timestamp = new Date(tempDate).getTime() - 1;
                return new Date(timestamp).getDate();
            },

            /*
             * 格式化日期
             * date 支持字符串型'2022-09-09'，支持Date型，也支持其他型（其他型会用new Date()代替）
             * type 显示格式：支持'date'，'time'
             * */
            formatDate(date, type) {
                let year = this.getYear(date);
                let month = this.getMonth(date);
                let date1 = this.getDate(date);
                let hours = this.getHours(date);
                let minutes = this.getMinutes(date);

                month = month > 9 ? month : "0" + month;
                date1 = date1 > 9 ? date1 : "0" + date1;
                hours = hours > 9 ? hours : "0" + hours;
                minutes = minutes > 9 ? minutes : "0" + minutes;

                return type === "date"
                    ? year + "-" + month + "-" + date1
                    : year + "-" + month + "-" + date1 + " " + hours + ":" + minutes;
            },

            formatDate_zero(year, month, date) {
                month = month > 9 ? month : "0" + month;
                date = date > 9 ? date : "0" + date;
                return year + '-' + month + '-' + date;
            },

            getYear(date) {
                return date.getFullYear();
            },
            getMonth(date) {
                return date.getMonth() + 1;
            },
            getDate(date) {
                return date.getDate();
            },
            getHours(date) {
                return date.getHours();
            },
            getMinutes(date) {
                return date.getMinutes();
            },

          getCurrentYearMonth(){
              return new Date().getFullYear()+"-"+(new Date().getMonth()+1);
          },
            removeClass(target, className) {
                let arr = target.className.split(" ");
                let index = arr.indexOf(className);
                if (index !== -1) {
                    arr.splice(index, 1);
                    target.className = arr.join(" ");
                }
            },

          // 获取两日期范围内的所有日期
          getAllChoosedDate(startDate, endDate){
            let dateArr = [];
            let index = 0;
            // 判断大小，并排序
            startDate = this.formatDateToDateTime(startDate);
            endDate = this.formatDateToDateTime(endDate);
            if(startDate.getTime() > endDate.getTime()){
              let temp = startDate;
              startDate = endDate;
              endDate = temp;
            }
            while(startDate.getTime() <= endDate.getTime()){
              let year = startDate.getFullYear()+'-';
              let month = (startDate.getMonth() + 1 < 10) ? '0' + (startDate.getMonth() + 1) + '-' : (startDate.getMonth() + 1) + '-';
              let day = (startDate.getDate() < 10) ? '0' + startDate.getDate() : startDate.getDate();
              dateArr[index] = year + month + day;
              let timestamp = startDate.getTime();
              startDate = new Date(timestamp + (24 * 60 * 60 * 1000));
              index++;
            }
            return dateArr;
          },

          // 按照兼容方式转换时间格式 2022-07-09 转为通用的Date格式，用于比较日期大小
          formatDateToDateTime(dateStr){
            dateStr = dateStr + " 00:00:00";
            return  new Date(dateStr.replace(/-/g, '/'));
          },

          // 日期数组排序 升序，支持比较的格式：2022-07-09
          dateCompare(dateA, dateB){
              return this.formatDateToDateTime(dateA).getTime() - this.formatDateToDateTime(dateB).getTime();
          }
        },
    };
</script>


<style lang="less" scoped>
    .wtc-choose-calendar {
        /*position: relative;*/
        width: 100%;
        overflow: hidden;
    }

    .wtc-choose-calendar .wtc-choose-calendar-week {
        display: flex;
        font-size: 12px;
        /*border-top: 1px solid #e5e5e5;*/
        padding: 10px 0;
        color: #212121;
        background: #F5F5F5;
    }

    .wtc-choose-calendar .weekend {
      color: #FF991C;
    }

    .wtc-choose-calendar-week .wtc-choose-calendar-week-item {
        flex: 1;
        text-align: center;
    }

    .wtc-choose-calendar .wtc-choose-calendar-head {
        text-align: center;
        padding: 10px 0;
    }

    .wtc-choose-calendar .wtc-choose-calendar-head .wtc-choose-calendar-cur-month {
        font-weight: 500;
        font-size: 14px;
        color: #212121;
    }

    .wtc-choose-calendar-head > div {
        display: inline-block;
        padding: 0 10px;
        font-size: 20px;
        vertical-align: bottom;
    }

    .wtc-choose-calendar-head .wtc-choose-calendar-left-month-btn-disable {
        color: #ccc;
    }

    .wtc-choose-calendar .wtc-choose-calendar-content-wrap {
        width: 300%;
        display: flex;
    }
    .wtc-choose-calendar .wtc-choose-calendar-content {
        font-size: 0;
        width: 100%;
    }

    .wtc-choose-calendar-content .wtc-choose-calendar-content-date-wrap {
        position: relative;
        font-size: 14px;
        display: inline-block;
        width: 14.2%;
        height: 14.2vw;
        /*height: 54px;
        padding: 5px 0px;*/
        margin: 4px 0px;
        box-sizing: border-box;
        cursor: pointer;
        padding: 5px;
    }

    .wtc-choose-calendar-content .pre-date,
    .wtc-choose-calendar-content .next-date {
        /*opacity: 0.5;*/
      opacity: 0;
        color: #fff;
    }

    .wtc-choose-calendar-content .choosed-date .wtc-choose-calendar-content-date {
        /*border: 1px solid #276ff5;
        background-color: #f2f9ff;
        color: #276ff5;*/
      border: 0px solid #276ff5 !important;
      border-radius: 50% !important;
      background-color: #276ff5 !important;
      color: #ffffff !important;
    }

    .wtc-choose-calendar-content .middle-start-choosed-date {

      border-top-left-radius: 50%;
      border-bottom-left-radius: 50%;
    }

    .wtc-choose-calendar-content .middle-end-choosed-date {
      border-top-right-radius: 50%;
      border-bottom-right-radius: 50%;
    }

    .wtc-choose-calendar-content .middle-choosed-date  {
      background-color: #E0EFFF;
    }

    .wtc-choose-calendar-content .choosed-date .wtc-choose-calendar-content-date .wtc-choose-calendar-content-date-apply .wtc-choose-calendar-content-date-apply-inner {
      background-color: #fffff1 !important;
    }

    /* .wtc-choose-calendar-content .wtc-choose-calendar-content-date {
          width: 24px;
          height: 24px;
          line-height: 24px;
          position: absolute;
          left: 50%;
          top: 50%;
          margin-left: -12px;
          margin-top: -12px;
          border-radius: 50%;
          overflow: hidden;
          text-align: center;
        } */

    .wtc-choose-calendar-content .wtc-choose-calendar-content-date {
        position: relative;
        height: 100%;
        box-sizing: border-box;
        overflow: hidden;
    }

    .wtc-choose-calendar-content .wtc-cld-date-today {
        color: #276ff5;
    }

    .wtc-choose-calendar-content .wtc-cld-date-actual-off {
        color: #999;
    }

    .wtc-choose-calendar-content .wtc-cld-date-rest {
        color: #999;
    }

    .wtc-choose-calendar-content .wtc-cld-date-actual-work {
        color: #212121;
    }

    .wtc-choose-calendar-content .wtc-cld-date-actual-off .wtc-choose-calendar-content-date-mark {
        background-color: #ff854d;
    }

    .wtc-choose-calendar-content .wtc-cld-date-actual-work .wtc-choose-calendar-content-date-mark {
        background-color: #16b8b1;
    }

    .wtc-choose-calendar-content-date .wtc-choose-calendar-content-date-mark {
        position: absolute;
        right: 0;
        top: 0;
        /* height: 18px; */
        font-size: 12px;
        width: 16px;
        height: 16px;
        color: #fff;
        border-radius: 2px;
        text-align: center;
    }

    .wtc-choose-calendar-content-date .wtc-choose-calendar-content-date-text {
        line-height: 100%;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
    }

    .wtc-choose-calendar-content-date .wtc-choose-calendar-content-date-apply {
        position: absolute;
        top: 80%;
        left: 50%;
        transform: translateX(-50%);
    }

    .wtc-choose-calendar-content-date .wtc-choose-calendar-content-date-apply .wtc-choose-calendar-content-date-apply-inner {
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: #276ff5;
    }
    /*.wtc-choose-calendar-content-date .wtc-choose-calendar-content-date-apply .wtc-choose-calendar-content-date-apply-inner {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      overflow: hidden;
      background-color: #ff5257;
    }*/
</style>
